import React from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faFacebookF,
  faXTwitter,
  faInstagram,
  faLinkedinIn,
  faYoutube,
} from "@fortawesome/free-brands-svg-icons";

const Footer = () => {
  const currentYear = new Date().getFullYear();



  return (
    <footer className="modern-footer">
      <div className="footer-main">
        <Container>
          <Row className="footer-content">
            <Col lg={4} md={6} className="mb-5 mb-md-4 mb-lg-0">
              <div className="footer-about">
                <Link to="/" className="logo">
                  <img
                    src="/img/logos/geosentry-logo-white-390.svg"
                    alt="Geosentry"
                    className="main-logo footer-logo-img"
                    loading="lazy"
                  />
                </Link>
                <p className="about-text">
                  Transforming location-based services with AI-powered solutions
                  for GPS tracking, optimal routing, and geofencing on Google
                  Cloud Platform.
                </p>
                <div className="social-links">
                  <a
                    href="https://www.facebook.com/geosentryai"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faFacebookF} />
                  </a>
                  <a
                    href="https://twitter.com/geosentry_ai"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faXTwitter} />
                  </a>
                  <a
                    href="https://www.instagram.com/geosentry_ai/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faInstagram} />
                  </a>
                  <a
                    href="https://www.linkedin.com/company/geosentry-ai/"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faLinkedinIn} />
                  </a>
                  <a
                    href="https://www.youtube.com/@geosentry_ai"
                    target="_blank"
                    rel="noreferrer"
                    className="social-icon"
                  >
                    <FontAwesomeIcon icon={faYoutube} />
                  </a>
                </div>
              </div>
            </Col>

            <Col lg={2} md={6} className="mb-5 mb-md-4 mb-lg-0">
              <div className="footer-links">
                <h4 className="footer-title">Quick Links</h4>
                <ul className="links-list">
                  <li>
                    <Link to="/about">About Us</Link>
                  </li>
                  <li>
                    <Link to="/service/fleet-management">Services</Link>
                  </li>
                  <li>
                    <Link to="/pricing">Pricing</Link>
                  </li>
                  <li>
                    <Link to="/contact">Contact Us</Link>
                  </li>
                  <li>
                    <Link to="/video">Media</Link>
                  </li>
                  <li>
                    <Link to="/privacy-policy" className="privacy-link">
                      Privacy Policy
                    </Link>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={3} md={6} className="mb-5 mb-md-0">
              <div className="footer-contact">
                <h4 className="footer-title">Contact Us</h4>
                <ul className="contact-list">
                  <li className="contact-item">
                    <div className="icon-box">
                      <i className="fas fa-phone-alt"></i>
                    </div>
                    <div className="contact-text">
                      <p className="contact-text-p">+91 91138-21395</p>
                    </div>
                  </li>
                  <li className="contact-item">
                    <div className="icon-box">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div className="contact-text">
                      <p className="contact-text-p">support@geosentry.ai</p>
                    </div>
                  </li>
                  <li className="contact-item">
                    <div className="icon-box address-icon">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div className="contact-text">
                      <p>
                        #10, 3rd A Cross, Ground Floor, Shakthi Layout, Sadaramangala Road, Kadugodi, Bangalore – 560067
                      </p>
                    </div>
                  </li>
                </ul>
              </div>
            </Col>

            <Col lg={3} md={6}>
              <div className="footer-apps">
                <h4 className="footer-title">Get the Apps</h4>
                <p className="footer-apps-desc">
                  Download our mobile app to track your assets, manage your
                  fleet, and receive real-time notifications on the go.
                  Available for both Android and iOS devices.
                </p>

                <div className="store-links">
                  <a
                    href="https://play.google.com/store/apps/developer?id=Geosentry+Private+Ltd"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg"
                      alt="Get it on Google Play"
                      className="store-badge"
                      loading="lazy"
                    />
                  </a>
                  <a
                    href="https://apps.apple.com/in/developer/murali-krishna/id1696330869"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img
                      src="https://developer.apple.com/assets/elements/badges/download-on-the-app-store.svg"
                      alt="Download on the App Store"
                      className="store-badge"
                      loading="lazy"
                    />
                  </a>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="footer-bottom">
        <Container>
          <div className="copyright">
            <p>
              &copy; {currentYear} Geosentry Private Limited. All rights
              reserved
            </p>
          </div>
        </Container>
      </div>

      <a href="#!" className="scroll-to-top">
        <i className="fas fa-chevron-up"></i>
      </a>

      <div className="footer-shape"></div>
    </footer>
  );
};

export default Footer;
